import React from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import { canUseDOM } from 'exenv';
import socialModel from './social_models';

function popupCenter(event, url, w, h) {
  if (canUseDOM) {
    event.preventDefault();

    const dualScreenLeft = window.screenLeft !== undefined
      ? window.screenLeft
      : screen.left;
    const dualScreenTop = window.screenTop !== undefined
      ? window.screenTop
      : screen.top;
    const width = window.innerWidth;
    const height = window.innerHeight;

    const left = width / 2 - w / 2 + dualScreenLeft;
    const top = height / 2 - h / 2 + dualScreenTop;

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/open
    const newWindow = window.open(
      url,
      'FC Share',
      `scrollbars=no, width=${w}, height=${h}, top=${top}, left=${left}`
    );

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }
}

/**
 * Sends a social event to GA to track user share activity
 * @param {String} socialPlatform (Facebook, Twitter, etc)
 * @param {String} action (Share, Tweet, etc)
 */

function trackSocial(socialPlatform, action) {
  if (canUseDOM && window.ga) {
    window.ga('send', 'social', socialPlatform, action, window.location.href);
    window.ga(
      'rollup.send',
      'social',
      socialPlatform,
      action,
      window.location.href
    );
  }
}

function handleClick(event, url, popup, socialShare) {
  if (socialShare.action !== 'email') {
    event.preventDefault();
  }

  if (popup) {
    popupCenter(event, url, 560, 725);
  }

  if (socialShare) {
    trackSocial(socialShare.platform, socialShare.action);
  }
}

function renderSocialList(empty, properties) {
  return (
    <ul className={`social__list ${empty ? 'social__list--post-empty' : ''}`}>
      {properties.map(sharer => {
        const { property, url, icon = '', popup, socialShare } = sharer;

        return (
          <li
            key={property}
            className={`social__item ${empty ? 'social__item--empty' : ''}`}
          >
            <a
              className={`social__link social__link--${property}`}
              href={url}
              onClick={e => handleClick(e, url, popup, socialShare)}
              rel="noopener noreferrer"
            >
              <i className={`icon-${icon || property}`} />
            </a>
          </li>
        );
      })}
    </ul>
  );
}

export default function Social(props) {
  if (!props) {
    return null;
  }

  const encodedPostUrl = props.uri;
  const encodedTitle = props.text;
  const properties = socialModel(encodedPostUrl, encodedTitle);
  const classes = ['social', `social--${props.modifier}`];

  return (
    <div className={classes.join(' ')} id={props.encapsulateId}>
      <Sticky
        top={props.topValue}
        bottomBoundary={props.bottomBoundary}
        enabled={props.enableSticky}
      >
        {renderSocialList(props.empty, properties)}
      </Sticky>
    </div>
  );
}

Social.defaultProps = {
  uri: 'https://www.fastcompany.com',
  text:
    'Fast Company is the world&#x27;s leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.',
  modifier: 'default',
  topValue: 56,
  bottomBoundary: 0,
  encapsulateId: '',
  empty: false,
  enableSticky: false
};

Social.propTypes = {
  empty: PropTypes.bool,
  enableSticky: PropTypes.bool,
  modifier: PropTypes.string,
  uri: PropTypes.string,
  text: PropTypes.string,
  bottomBoundary: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  encapsulateId: PropTypes.string,
  topValue: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/views/components/social/social.js